module.exports = __webpack_public_path__ + "img/skip.4b005d5f.jpg";